import {Logger} from "../../logger/Logger";

/** Extract error code/message from various error types (string, Error, RpcError object) */
const normalizeErrorInput = (input: unknown): string | undefined => {
  if (typeof input === 'string') return input;
  if (input && typeof input === 'object') {
    const obj = input as Record<string, unknown>;
    // RpcError: { code, message, metadata }
    if (typeof obj.code === 'string') return obj.code;
    if (typeof obj.message === 'string') return obj.message;
  }
  return undefined;
};

//TODO localization
export const getErrorMessageByCode = (code?: string | unknown) => {
  const normalized = normalizeErrorInput(code);
  switch (normalized) {
    case 'AUTH_ERROR_IDENTIFIER_REFRESH_TOKEN_NOT_FOUND':
      return 'Refresh token is missing.';
    case 'AUTH_ERROR_IDENTIFIER_PASSWORD_NOT_MATCH':
      return 'Incorrect credentials.';
    case 'AUTH_ERROR_IDENTIFIER_USER_NOT_FOUND':
      return 'Incorrect credentials.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_DEFAULT':
      return 'Unexpected account error.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_USER_CREATE_ERROR':
      return 'Unexpected account error.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_USER_EMAIL_NOT_VALID':
      return 'Incorrect email.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_USER_FLY_COMPANY_ID_INVALID':
      return 'Incorrect freighter company.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_USER_AGENCY_COMPANY_ID_INVALID':
      return 'Incorrect charterer company.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_TARIFF_ID_INVALID':
      return 'Incorrect tariff.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_FIO_INVALID':
      return 'Incorrect full name.';
    case 'AUTH_ERROR_IDENTIFIER_REGISTRATION_REQUIREMENT_FIELD':
      return 'Required fields not filled.';
    case 'AUTH_ERROR_IDENTIFIER_REGISTRATION_TYPE_MISMATCH_FIELD':
      return 'Type mismatch of filled fields.';
    case 'AUTH_ERROR_IDENTIFIER_REGISTRATION_EMAIL_VALIDATION':
      return 'Type mismatch of filled fields.';
    case 'AUTH_ERROR_IDENTIFIER_REGISTRATION_PASSWORD_VALIDATION':
      return 'Incorrect password.';
    case 'AUTH_ERROR_IDENTIFIER_REGISTRATION_ROLE_VALIDATION':
      return 'Incorrect role.';
    case 'AUTH_ERROR_IDENTIFIER_REGISTRATION_INVALID_CHARACTERS':
      return 'Some fields contain invalid characters. Please check your input and use only allowed characters.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_REQUIRED_MISSED':
      return 'All required fields are not filled.';
    case 'BOOKING_ERROR_IDENTIFIER_EMPTY_LEG_PLANE_BUSY':
      return 'Aircraft is busy on the indicated dates.';
    case 'BOOKING_EMPTY_LEG_ERROR_IDENTIFIER_INCORRECT_TIME':
      return 'The flight time or dates are incorrect. Please verify that the flight duration matches the route and the dates are valid.';
    case 'BOOKING_IDENTIFIER_SAME_ORDER_ROUTE_EXIST':
      return 'A request with the same route already exists. Please check your existing requests.';
    case 'PLANE_ERROR_IDENTIFIER_UNABLE_TO_DELETE':
      return 'Unable to delete an aircraft with existing flights.';
    case 'PLANE_ERROR_IDENTIFIER_REGISTRATION_NUMBER_INVALID':
      return 'Registration number is too long. Maximum length is 255 characters.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_USER_NOT_FOUND':
      return 'Link expired';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_OLD_PASSWORD_NOT_VALID':
      return 'Invalid old password';
    case 'SCHEDULE_ERROR_IDENTIFIER_PLANE_BUSY':
      return 'Aircraft is busy on the indicated dates.';
    case 'EVENT_CALENDAR_ERROR_IDENTIFIER_NOT_FOUND':
      return 'Event not found. It may have been deleted or you do not have permission to access it.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_TRIAL_MANAGER_LIMIT_REACHED':
      return 'Trial mode allows adding up to 7 users. Please upgrade your subscription to add more.';
    case 'USER_ACCOUNT_ERROR_IDENTIFIER_SEAT_LIMIT_REACHED':
      return 'You have reached your seat limit. Ask your company administrator to buy more seats in Subscription.';
    case 'PLANE_ERROR_IDENTIFIER_TRIAL_AIRCRAFT_LIMIT_REACHED':
      return 'Trial mode allows adding up to 7 aircraft. Please upgrade your subscription to add more.';
    case 'PLANE_ERROR_IDENTIFIER_AIRCRAFT_SLOT_LIMIT_REACHED':
      return 'You have reached your aircraft slot limit. Ask your company administrator to buy more slots in Subscription.';
    case 'UNIMPLEMENTED':
      return 'This feature is not yet available. Please try again later.';
    default:
      Logger.error(`Unknown error. Error code: ${normalized}`)
      // Return a safe string - never return object (causes "Objects are not valid as React child")
      return typeof normalized === 'string' ? normalized : 'Unknown error.'
  }
}
